import { NgModule, ApplicationRef } from "@angular/core";
import {MockBackend} from "@angular/http/testing";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HttpModule, BaseRequestOptions, Http } from "@angular/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { routing } from "./app.routing";
import { removeNgStyles, createNewHosts } from "@angularclass/hmr";

import "hammerjs";

import { LoginComponent } from "./components/login/login.component";
import { AppComponent } from "./components/app/app.component";
import { MaterialModule } from "@angular/material";
import { FlexLayoutModule } from "@angular/flex-layout";
import { CdkTableModule } from "@angular/cdk";
import { APIService } from "./services/login/api";
import { ResetPasswordComponent } from "./components/reset-password/reset-password.component";
import { ForgotPasswordComponent } from "./components/forgot-password/forgot-password.component";
import { ForgotPasswordDialogComponent } from "./components/login/forgot-password-dialog/forgot-password-dialog.component";
import { ConfirmEmailSentDialogComponent } from "./components/login/confirm-email-sent-dialog/confirm-email-sent-dialog.component";
import { ConfirmPasswordSetDialogComponent } from "./components/forgot-password/confirm-password-set-dialog/confirm-password-set-dialog.component";
import { ErrorDialogComponent } from "./components/forgot-password/error-dialog/error-dialog.component";
import {MyBackendService} from "./services/my-backend";
import { NewPortalAlertComponent } from "./components/new-portal-alert/new-portal-alert.component";

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    //Disable httpModule in mock
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    routing,
    MaterialModule,
    FlexLayoutModule,
    CdkTableModule
  ],
  declarations: [
    AppComponent,
    LoginComponent,
    ResetPasswordComponent,
    ForgotPasswordComponent,
    ForgotPasswordDialogComponent,
    ConfirmEmailSentDialogComponent,
    ConfirmPasswordSetDialogComponent,
    ErrorDialogComponent,
    NewPortalAlertComponent
  ],
  entryComponents: [
    // Dialogs
    ForgotPasswordDialogComponent,
    ConfirmEmailSentDialogComponent,
    ConfirmPasswordSetDialogComponent,
    ErrorDialogComponent,
    NewPortalAlertComponent,
  ],
  providers: [
    APIService,
    BaseRequestOptions,
    MyBackendService,
    MockBackend,
    // {
    //   provide: Http, deps: [MyBackendService, BaseRequestOptions],
    //   useFactory: (backend, options) => {
    //     return new Http(backend, options);
    //   }
    // }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(public appRef: ApplicationRef) {}

  hmrOnInit(store) {
    console.log("HMR store", store);
  }
  hmrOnDestroy(store) {
    let cmpLocation = this.appRef.components.map(
      cmp => cmp.location.nativeElement
    );
    // recreate elements
    store.disposeOldHosts = createNewHosts(cmpLocation);
    // remove styles
    removeNgStyles();
  }
  hmrAfterDestroy(store) {
    // display new elements
    store.disposeOldHosts();
    delete store.disposeOldHosts;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app.module.ts